"use client";

import { Mail, Instagram, Globe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function IrisMark({
  className = ""
}: {
  className?: string;
}) {
  return;
}
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground font-default text-sm tracking-wide relative inline-block group">
            <span className="relative">
              {item.label}
              <span className="absolute left-0 right-0 h-px bg-primary transition-all duration-300 group-hover:h-0.5 group-hover:right-[-8px]" style={{
            bottom: "-6px"
          }} />
            </span>
          </Link>
        </li>)}
    </ul>;
}
const tickerText = "ECO GROW COMMUNITY  ·  ORGANIC FARMING  ·  NEIGHBORHOOD GARDEN  ·  SUSTAINABLE LIVING  ·  ";
const socials = [{
  label: "Instagram",
  href: "https://instagram.com",
  icon: "instagram"
}, {
  label: "Community Hub",
  href: "https://are.na",
  icon: "globe"
}, {
  label: "Email",
  href: "mailto:hello@ecogrow.org",
  icon: "mail"
}];
export default function Footer() {
  return <section data-section-id="1798" id="footer" className="bg-background text-foreground pt-24 pb-12 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 flex items-center">
        <span className="w-2 h-2 bg-primary -ml-1" />
        <span className="flex-1 h-px bg-primary" />
        <span className="w-2 h-2 bg-primary -mr-1" />
      </div>

      {}
      

      {}
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-20 pb-12">
        {}
        

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          {}
          <div className="md:col-span-4 flex flex-col gap-8">
            <div className="flex items-center gap-3">
              <Link to="/" className="flex items-center gap-3">
                <WvcLogo className="h-7 w-auto" />
              </Link>
              <IrisMark className="w-6 h-6 text-primary" />
            </div>

            <div className="flex flex-col gap-5">
              <p className="font-default italic text-lg md:text-xl leading-relaxed text-foreground/95">
                Cultivating community, one plot at a time.
              </p>
              <div className="flex items-center gap-3">
                <span className="w-10 h-px bg-primary" />
                <span className="w-1 h-1 bg-primary rounded-lg" />
              </div>
              <p className="font-mono text-xs tracking-[0.12em] uppercase text-muted-foreground leading-relaxed">
                Open Daily · Sunrise to Sunset
                <br />
                Community Workshops Weekly
              </p>
              <p className="font-mono text-xs tracking-[0.12em] uppercase text-muted-foreground">
                +1 555 012 3456
              </p>
            </div>
          </div>

          {}
          <div className="md:col-span-4 md:pl-8 flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-muted-foreground">
              Navigate
            </div>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4 flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-muted-foreground">
              Elsewhere
            </div>
            <ul className="flex flex-col gap-4">
              {socials.map((s, i) => <li key={s.label} data-index={i}>
                  <Link to={s.href} newTab className="text-foreground font-default text-sm tracking-wide inline-flex items-center gap-3 group">
                    {s.icon === "instagram" && <Instagram className="w-4 h-4 stroke-[1.25] text-foreground group-hover:text-primary transition-colors duration-300" />}
                    {s.icon === "globe" && <Globe className="w-4 h-4 stroke-[1.25] text-foreground group-hover:text-primary transition-colors duration-300" />}
                    {s.icon === "mail" && <Mail className="w-4 h-4 stroke-[1.25] text-foreground group-hover:text-primary transition-colors duration-300" />}
                    <span className="relative">
                      {s.label}
                      <span className="absolute left-0 right-0 h-px bg-primary transition-all duration-300 group-hover:h-0.5 group-hover:right-[-8px]" style={{
                    bottom: "-6px"
                  }} />
                    </span>
                  </Link>
                </li>)}
              <li data-index={3}>
                <Link to="mailto:hello@ecogrow.org" className="text-muted-foreground font-mono text-xs tracking-[0.12em] uppercase hover:text-primary transition-colors duration-300">
                  hello@ecogrow.org
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="mt-20 flex items-center">
          <span className="w-2 h-2 bg-primary rounded-lg" />
          <span className="flex-1 h-px bg-primary" />
          <span className="w-2 h-2 bg-primary rounded-lg" />
        </div>

        {}
        <div className="flex justify-center my-12">
          <IrisMark className="w-12 h-12 md:w-14 md:h-14 text-primary" />
        </div>

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-muted-foreground">© 2026 ECO GROW · COMMUNITY GARDEN</p>
          <ul className="flex items-center gap-6 md:gap-8">
            {[{
            label: "Imprint",
            to: "#"
          }, {
            label: "Privacy",
            to: "#"
          }, {
            label: "Cookies",
            to: "#"
          }].map((item, i) => <li key={item.label} data-index={i}>
                <Link to={item.to} className="text-muted-foreground font-mono text-[0.6875rem] tracking-[0.18em] uppercase hover:text-primary transition-colors duration-300">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}